import { addFilter } from '@wordpress/hooks';
import { useBlockProps } from '@wordpress/block-editor';
import { createElement } from '@wordpress/element';

/**
 * Legacy SB feed blocks that ship apiVersion: 3 but whose edit() function
 * returns an array of React elements without wrapping a root DOM element in
 * useBlockProps(). Without that wrapper, the WP 7.0+ iframed editor cannot
 * position the block toolbar / move handles, so the only way to select or
 * reorder the block is through List View. This filter wraps the legacy
 * edit() so the block UI works on the canvas again, without touching each
 * plugin's own block JS.
 */
const LEGACY_SB_BLOCK_NAMES = [
	'sbi/sbi-feed-block',
	'cff/cff-feed-block',
	'ctf/ctf-feed-block',
	'sby/sby-feed-block',
];

function getTargetBlockNames() {
	const fromRegistry = ( window.sbFeedBlocksRegistry || [] )
		.map( ( config ) => config && config.legacyBlockName )
		.filter( Boolean );
	return new Set( [ ...LEGACY_SB_BLOCK_NAMES, ...fromRegistry ] );
}

const targetBlockNames = getTargetBlockNames();

function wrapEdit( OriginalEdit ) {
	return function LegacyBlockEditWrapper( props ) {
		const blockProps = useBlockProps();
		return createElement(
			'div',
			blockProps,
			createElement( OriginalEdit, props )
		);
	};
}

addFilter(
	'blocks.registerBlockType',
	'sb-common/legacy-block-props-wrapper',
	( settings, name ) => {
		if ( ! targetBlockNames.has( name ) ) {
			return settings;
		}
		if ( ! settings || typeof settings.edit !== 'function' ) {
			return settings;
		}
		settings.edit = wrapEdit( settings.edit );
		return settings;
	}
);
